import { CustomBaseStore } from '@city/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CityState, StateWithCity } from '../city-state';
import { getCityState } from './feature.selector';

export const getBaseStoresState: MemoizedSelector<
  StateWithCity,
  StateUtils.LoaderState<CustomBaseStore[]>
> = createSelector(getCityState, (state: CityState) => state.baseStores);

export const getBaseStoresValue: MemoizedSelector<StateWithCity, CustomBaseStore[]> = createSelector(
  getBaseStoresState,
  (state: StateUtils.LoaderState<CustomBaseStore[]>) => StateUtils.loaderValueSelector(state),
);

export const getBaseStoresLoading: MemoizedSelector<StateWithCity, boolean> = createSelector(
  getBaseStoresState,
  (state: StateUtils.LoaderState<CustomBaseStore[]>) => StateUtils.loaderLoadingSelector(state),
);

export const getBaseStoresError: MemoizedSelector<StateWithCity, boolean> = createSelector(
  getBaseStoresState,
  (state: StateUtils.LoaderState<CustomBaseStore[]>) => StateUtils.loaderErrorSelector(state),
);

export const getBaseStoresSuccess: MemoizedSelector<StateWithCity, boolean> = createSelector(
  getBaseStoresState,
  (state: StateUtils.LoaderState<CustomBaseStore[]>) => StateUtils.loaderSuccessSelector(state),
);

export const getActiveBaseStore: MemoizedSelector<StateWithCity, string> = createSelector(
  getCityState,
  (state: CityState) => state.activeBaseStore,
);

export const getTemporaryBaseStore: MemoizedSelector<StateWithCity, string> = createSelector(
  getCityState,
  (state: CityState) => state.tempBaseStore,
);
